<template>
  <layout-default :is-loaded="true">
    <v-layout
            wrap
    >

      <v-flex>
        <div class="mt-4 mx-auto d-flex justify-center" style=" position: relative">
          <!--<avatar size="large" color="primary" class="primary" :img="getDoctorContent.avatar"
                  :name="getDoctorContent.first_name"></avatar>-->
          <avatar-uploader v-if="getUserProfile" class="" :user_name="getUserProfile.first_name" @user:updated="fetchUserProfile" :file="getUserProfile.avatar" :user_id="getUserData.id" ref="avatar"></avatar-uploader>
        </div>

<!--        <avatar class="ml-0 mb-5" img="avatar.jpg" size="medium"></avatar>-->



        <!--<div class="mb-2 ml-4" style="z-index: 5; position: relative;">
          <v-btn class="ml-0 mr-4"  @click.stop="dialog=!dialog" color="primary"  small fab>
            <v-icon

                    size="18"
                    color="white"
            >
              mdi-pencil
            </v-icon>
          </v-btn>
        </div>-->

        <v-card max-width="500" v-if="getUserProfile" class="pt-0 mt-4 mx-auto" flat>
          <v-card-text class="text-left pt-0 ">
<div class="d-flex pt-4 align-center justify-space-between" >


  <div class=" white--text" style=" position: relative">
    <h3>{{ getUserProfile ? getUserProfile.first_name + ' ' + getUserProfile.last_name  + ' ' + getUserProfile.patronymic : '' }}</h3>
    <div style="line-height: 1" class="grey--text mt-2 overline mt-0 lighten-1" v-if="getUserProfile">{{ role }}</div>

    <!--<v-icon @click="dialog=!dialog" size="24" color="primary" class="ml-2 mt-1 float-right">mdi-pencil</v-icon>-->
  </div>

  <v-btn class="ml-4"  @click-old.stop="dialog=!dialog" color="primary"  small fab>
    <v-icon

            size="18"
            color="white"
    >
      mdi-pencil
    </v-icon>
  </v-btn>
</div>

            <v-list  two-line >

              <v-list-item @click="">
                <v-list-item-icon>
                  <v-icon color="orange">mdi-calendar</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ getUserProfile.birthday }}</v-list-item-title>
                  <v-list-item-subtitle ><span class="caption">Дата рождения</span></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider ></v-divider>
              <v-list-item @click="">
                <v-list-item-icon>
                  <v-icon color="purple">mdi-email</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ getUserProfile.email }}</v-list-item-title>
                  <v-list-item-subtitle ><span class="caption">E-Mail</span></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider ></v-divider>
              <v-list-item @click="">
                <v-list-item-icon>
                  <v-icon color="green">mdi-phone</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ getUserProfile.phone }}</v-list-item-title>
                  <v-list-item-subtitle ><span class="caption">Телефон</span></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider ></v-divider>
              <v-list-item @click="">
                <v-list-item-icon>
                  <v-icon color="blue">mdi-earth</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ getUserProfile.country }}</v-list-item-title>
                  <v-list-item-subtitle ><span class="caption">Страна</span></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider ></v-divider>
              <v-list-item @click="">
                <v-list-item-icon>
                  <v-icon color="red">mdi-map-marker</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ getUserProfile.city }}</v-list-item-title>
                  <v-list-item-subtitle ><span class="caption">Город</span></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
<!--              <v-divider ></v-divider>-->

            </v-list>

            <!--<div class="mt-5 mb-2">
              <v-btn @click="dialog=!dialog" class="float-right" small color="primary">
                <v-icon size="14" class="mr-1 ml-n1">mdi-pencil</v-icon> Edit
              </v-btn>
              <br>
            </div>-->

          </v-card-text>
        </v-card>
      </v-flex>

      <v-dialog v-model="dialog" max-width="500px"  class="mt-4" fullscreen  transition="dialog-bottom-transition">
        <v-card class="text-left">
          <v-system-bar color="white">
            <!--<v-spacer></v-spacer>-->
            <v-btn class="mt-8 " icon dark @click.stop="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-system-bar>

          <v-card-title class="" style="margin-top: 110px;">


            <h2 class=" mb-8" style="font-size: 28px; line-height: 1.35;">
              <span class="font-weight-bold"> Edit Profile</span>
            </h2>
            <!--<span class="headline">{{ formTitleAppointment }}</span>-->
          </v-card-title>

          <v-card-text v-if="editedProfile">
            <v-form ref="formProfile">
                <v-row no-gutters>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field :rules="nameRules" v-model="editedProfile.first_name" label="First name"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedProfile.last_name" label="Last name"></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="4">


                    <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                                v-model="editedProfile.birthday"
                                label="Birthday"
                                append-icon="mdi-calendar"
                                readonly
                                v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                              ref="picker"
                              v-model="editedProfile.birthday"
                              :max="new Date().toISOString().substr(0, 10)"
                              min="1920-01-01"
                              @change="save"
                      ></v-date-picker>

                    </v-menu>
                    <!--<v-text-field  v-model="editedProfile.birthday" label="Birthday"></v-text-field>-->
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field :rules="emailRules" v-model="editedProfile.email" label="Email"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedProfile.phone" label="Phone"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="6">
                    <v-btn color="grey" width="100%" large tile class="white--text" @click.stop="dialog = false">Cancel</v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-btn color="primary" large tile class="white--text"  width="100%"   @click="postProfile">Save</v-btn>
                  </v-col>
                </v-row>
            </v-form>

          </v-card-text>
        </v-card>
      </v-dialog>


    </v-layout>
  </layout-default>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import LayoutDefault from '@/layouts/LayoutClient.vue'
  import AvatarUploader from '@/components/users/AvatarUploader'
  import Avatar from '@/components/avatar'
  export default {
    name: 'Profile',
    components: {
      LayoutDefault,
      AvatarUploader,
      Avatar
    },
    data: () => ({
      dialog: false,
      menu: false,
      editedProfile: null,
      nameRules: [
        v => !!v || 'Name is required',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ]
    }),
    computed: {
      ...mapGetters({
        getIsUserLoggedIn: 'auth/getIsUserLoggedIn',
        getUserData: 'auth/getUserData',
        getErrors: 'auth/getErrors',
        getUserProfile: 'auth/getUserProfile'
      }),
      currentRouteName () {
        return this.$route.name
      },
      role() {
        if (this.getUserProfile) {
          switch (this.getUserProfile.role) {
            case 'user':
              return 'Участник'
              break;
            case 'painter':
              return 'Художник'
              break;
            case 'profi':
              return 'Профи'
              break;
            case 'collector':
              return 'Коллекционер'
              break;
          }
        } else {
          return '—'
        }
      }
    },
    methods: {
      ...mapActions({
        fetchUserProfile: 'auth/fetchUserProfile',
        saveProfile: 'auth/saveProfile',
        clearErrors : 'auth/clearErrors'
      }),
      postProfile: async function() {
        try {
          this.clearErrors()

          if (!this.$refs.formProfile.validate()) {
            return false
          }

          await this.saveProfile(
            this.editedProfile
          )
          if (this.getErrors.length > 0) {
            this.alertError = true
          } else {
            this.alertError = false
            this.dialog = false
            await this.fetchUserProfile()
          }

        } catch (e) {
          console.log('error', e)
        }
      },
      save (date) {
        this.$refs.menu.save(date)
      }
    },
    watch: {
      menu (val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      },
    },
    async created () {
      await this.fetchUserProfile()
      this.editedProfile = this.getUserProfile
    }
  }
</script>
